<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="用户ID" prop="userId"><el-input v-model="form.userId" placeholder="用户ID" /></el-form-item>
      <el-form-item label="模板类型" prop="templateType"><el-select v-model="form.templateType" placeholder="模板类型">
        <el-option label="日记模板" value="diary_write" />
        <el-option label="洞察模板" value="insight_detail" />
        <el-option label="手记模板" value="share_handnote" />
      </el-select></el-form-item>
      <el-form-item label="模板配置ID" prop="templateConfigId"><el-input v-model="form.templateConfigId" placeholder="模板配置ID" /></el-form-item>
      <el-form-item label="是否自定义" prop="isCustomized"><el-select v-model="form.isCustomized" placeholder="是否自定义">
        <el-option label="否" value="0" />
        <el-option label="是" value="1" />
      </el-select></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operauserTemplateMappingWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, userId: '', templateType: '', templateConfigId: '', isCustomized: '0' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/userTemplateMapping', 'field.id': 'id' }) }
}
</script>